export default __webpack_public_path__ + "static/media/bowtie.52e41da9.svg";